import { createReducer, on } from '@ngrx/store';
import { DocumentSearchState } from '../../inventory/document-filter-form/document-filter-form.component';
import { HivelogDocumentType } from '../../inventory/document-type';
import { HivelogDocument } from '../../inventory/hivelog-document';
import * as DocumentsActions from './documents.actions';

export interface DocumentsState {
  documents: HivelogDocument[];
  documentTypes: HivelogDocumentType[];
  tableFilter: DocumentSearchState;
}

const initialState: DocumentsState = {
  documents: [],
  documentTypes: [],
  tableFilter: {}
};

export const DocumentsReducer = createReducer(
  initialState,
  on(DocumentsActions.getDocumentsSuccess, (state, {documents}) => ({
    ...state,
    documents
  })),
  on(DocumentsActions.updateTableFilter, (state, {tableFilter}) => ({
    ...state,
    tableFilter
  })),
  on(DocumentsActions.getDocumentTypesSuccess, (state, {documentTypes}) => ({
    ...state,
    documentTypes
  }))
);
